const deleteClassReducer = (state = {}, action) => {
    switch (action.type) {
      case "DELETE_CLASS": {
        return{
          ...state,
          deleteClassSuccess: action.success
        }
      }
      case "DELETE_CLASS_ERR": {
        return{
          ...state,
          deleteClassError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default deleteClassReducer;
  